import Tooltip from 'antd/lib/tooltip';
import { toAllowedStringLength } from '../common/formattersToAllowedValueLength';
import { IProgram } from './interface';
import { ColumnFilterItem } from 'antd/lib/table/interface';

export const buildProgramFilter = (programs: IProgram[], includeWithoutProgram: boolean = false): ColumnFilterItem[] => {
    const filterOptionList: ColumnFilterItem[] = programs.map(p => ({
        text: (
            <Tooltip title={p.name} placement="right">
                {toAllowedStringLength(p.name)}
            </Tooltip>
        ),
        fullText: p.name,
        value: p.program_id,
    }));

    if (includeWithoutProgram) {
        filterOptionList.unshift({ text: 'No Program', fullText: 'No Program', value: 'null' });
    }

    return filterOptionList;
};
